import { render, staticRenderFns } from "./SkillsView.vue?vue&type=template&id=a232e3be&"
import script from "./SkillsView.vue?vue&type=script&lang=js&"
export * from "./SkillsView.vue?vue&type=script&lang=js&"
import style0 from "./SkillsView.vue?vue&type=style&index=0&id=a232e3be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports